import {
  Alert,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCompteResultatBilanSchema } from "../schema";
import * as actions from "../redux/state/CompteResultatBilansAction";
import * as actionsCompanies from "../../../../companies/redux/state/CompaniesAction";
import * as modalActions from "../modalActionTypes";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { getErrorMessage } from "common/utils/Helper";

export default function FormUpdateCompteResultatBilan({
  setOpen,
  compteResultatBilanId,
  setCompteResultatBilanId,
  setAction,
  companyId,
  setCompanyId,
}) {
  const dispatch = useDispatch();
  const location = useLocation();

  const [errorSB, setErrorSB] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const openErrorSB = () => setErrorSB(true);
  const closeErrorSB = () => setErrorSB(false);

  // order select companies
  const orderCompanies = {
    sort: "raison_social",
    order: "asc",
  };
  useEffect(() => {
    dispatch(actions.editCompteResultatBilan(compteResultatBilanId));
    dispatch(actionsCompanies.getCompanies(orderCompanies));
  }, []);
  const compteResultatBilan = useSelector(
    (state) => state?.compteResultatBilans?.compteResultatBilan
  );
  const [value, setValue] = useState(dayjs(compteResultatBilan?.date));

  const companies = useSelector((state) => state?.companies.companies);
  const handleClose = () => {
    setOpen(false);
  };
  const onSubmit = (values) => {
    const request = {
      payload: values,
      successCallBack: (response) => {
        closeErrorSB()
        setCompanyId(values?.company_id ?? companyId);
        setAction(modalActions.ADD);
        setCompteResultatBilanId("");
        setOpen(false);
        let queryParam = {};
        if (
          (companyId.toString().length > 0 && companyId !== undefined) ||
          (values?.company_id.toString().length > 0 && values?.company_id !== undefined)
        ) {
          queryParam = { companyId: values?.company_id ?? companyId, sort: "date", order: "desc" };
        }
        dispatch(actions.getCompteResultatBilans(queryParam));
        console.log("response", response);
      },
      failCallBack: (error) => {
        console.log("error", error);
        setErrorMessage(getErrorMessage(error))
        openErrorSB();
      },
    };
    dispatch(actions.updateCompteResultatBilan(request));
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: compteResultatBilan?.id,
      total_production_exploitation: compteResultatBilan?.total_production_exploitation,
      chiffre_affaire_net: compteResultatBilan?.chiffre_affaire_net,
      cout_vente: compteResultatBilan?.cout_vente,
      marge_brut: compteResultatBilan?.marge_brut,
      autre_charge_exploitation: compteResultatBilan?.autre_charge_exploitation,
      resultat_exploitation: compteResultatBilan?.resultat_exploitation,
      resultat_financier: compteResultatBilan?.resultat_financier,
      produit_financier: compteResultatBilan?.produit_financier,
      charge_financier: compteResultatBilan?.charge_financier,
      resultat_courant_avant_impot: compteResultatBilan?.resultat_courant_avant_impot,
      impot_taxe_assimitee: compteResultatBilan?.impot_taxe_assimitee,
      resultat_courant_apres_imposition: compteResultatBilan?.resultat_courant_apres_imposition,
      resultat_exceptionnel: compteResultatBilan?.resultat_exceptionnel,
      change_exceptionnelle: compteResultatBilan?.change_exceptionnelle,
      benefice_pert: compteResultatBilan?.benefice_pert,
      date: compteResultatBilan?.date,
      company_id: compteResultatBilan?.company_id,
      exceptional_products: compteResultatBilan?.exceptional_products,
    },
    validationSchema: updateCompteResultatBilanSchema,
    onSubmit,
  });

  const disabledSelect = location?.state?.id ? true: false;

  const { handleSubmit, errors, values, handleChange } = formik;

  console.log("values:::",values,"compteResultatBilan:::",compteResultatBilan)
  return (
    <MDBox m={1}>
      {errorSB && (
        <Alert severity="error">
          {errorMessage}
        </Alert>
      )}
      {compteResultatBilan && values.id!==undefined &&
      <form onSubmit={handleSubmit}>
        <MDBox py={2}>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="total_production_exploitation"
                  label="Total des productions exploitations"
                  error={errors.total_production_exploitation ? true : false}
                  onChange={handleChange}
                  value={values?.total_production_exploitation?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.total_production_exploitation ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="chiffre_affaire_net"
                  label="Chiffre d'affaires net"
                  error={errors.chiffre_affaire_net ? true : false}
                  onChange={handleChange}
                  value={values.chiffre_affaire_net?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.chiffre_affaire_net ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="cout_vente"
                  label="Cout des ventes"
                  error={errors.cout_vente ? true : false}
                  onChange={handleChange}
                  value={values.cout_vente?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.cout_vente ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="marge_brut"
                  label="Marge brut"
                  error={errors.marge_brut ? true : false}
                  onChange={handleChange}
                  value={values.marge_brut?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.marge_brut ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="autre_charge_exploitation"
                  label="Autres charges d'exploitation"
                  error={errors.autre_charge_exploitation ? true : false}
                  onChange={handleChange}
                  value={values.autre_charge_exploitation?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.autre_charge_exploitation ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="resultat_exploitation"
                  label="Resultat d'exploitation"
                  error={errors.resultat_exploitation ? true : false}
                  onChange={handleChange}
                  value={values.resultat_exploitation?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.resultat_exploitation ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="resultat_financier"
                  label="Resultat financier"
                  error={errors.resultat_financier ? true : false}
                  onChange={handleChange}
                  value={values.resultat_financier?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.resultat_financier ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="produit_financier"
                  label="Produit_financier"
                  error={errors.produit_financier ? true : false}
                  onChange={handleChange}
                  value={values.produit_financier?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.produit_financier ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="charge_financier"
                  label="Charge financier"
                  error={errors.charge_financier ? true : false}
                  onChange={handleChange}
                  value={values.charge_financier?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.charge_financier ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="resultat_courant_avant_impot"
                  label="Resultat courant avant impots"
                  error={errors.resultat_courant_avant_impot ? true : false}
                  onChange={handleChange}
                  value={values.resultat_courant_avant_impot?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.resultat_courant_avant_impot ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="impot_taxe_assimitee"
                  label="Impot et taxes assimitees"
                  error={errors.impot_taxe_assimitee ? true : false}
                  onChange={handleChange}
                  value={values.impot_taxe_assimitee?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.impot_taxe_assimitee ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="resultat_courant_apres_imposition"
                  label="Resultat courant apres imposition"
                  error={errors.resultat_courant_apres_imposition ? true : false}
                  onChange={handleChange}
                  value={
                    values.resultat_courant_apres_imposition?.toString().replace(",", ".") ?? ""
                  }
                  helperText={errors?.resultat_courant_apres_imposition ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="resultat_exceptionnel"
                  label="Resultat exceptionnels"
                  error={errors.resultat_exceptionnel ? true : false}
                  onChange={handleChange}
                  value={values.resultat_exceptionnel?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.resultat_exceptionnel ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="exceptional_products"
                  label="Produits exceptionnels"
                  error={errors.exceptional_products ? true : false}
                  onChange={handleChange}
                  value={values.exceptional_products?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.exceptional_products ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="change_exceptionnelle"
                  label="Changes exceptionnelles"
                  error={errors.change_exceptionnelle ? true : false}
                  onChange={handleChange}
                  value={values.change_exceptionnelle?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.change_exceptionnelle ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <MDInput
                  name="benefice_pert"
                  label="Benefices ou perts"
                  error={errors.benefice_pert ? true : false}
                  onChange={handleChange}
                  value={values.benefice_pert?.toString().replace(",", ".") ?? ""}
                  helperText={errors?.benefice_pert ?? ""}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <FormControl fullWidth>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    renderInput={(props) => <TextField {...props} />}
                    name="date"
                    value={value}
                    error={errors.date ? true : false}
                    onChange={(newValue) => {
                      setValue(newValue);
                      formik.setFieldValue("date", dayjs(newValue).format("YYYY-MM-DD"));
                    }}
                  />
                </LocalizationProvider>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <FormControl fullWidth>
                <InputLabel id="company_id">Entreprise</InputLabel>
                <Select
                  name="company_id"
                  style={{ height: "40px" }}
                  labelId="state_label"
                  label="Entreprise"
                  error={errors.company_id ? true : false}
                  onChange={handleChange}
                  value={values.company_id ?? ""}
                  disabled = {disabledSelect}
                >
                  {companies?.data?.map((company) => {
                    return (
                      <MenuItem key={company?.id} value={company?.id}>
                        {/* <b>{company?.raison_social}</b>&nbsp;({company?.country_id}) */}
                        <p>
                          <b>{company?.raison_social}</b> ({company?.country?.name})
                        </p>
                      </MenuItem>
                    );
                  })}
                </Select>
                {errors.country_id ? (
                  <FormHelperText error>{errors?.company}</FormHelperText>
                ) : null}
              </FormControl>
            </Grid>
          </Grid>
        </MDBox>

        <MDBox sx={{ display: "flex" }}>
          <MDBox mr={1} sx={{ flexGrow: "1" }}>
            <MDButton onClick={handleClose} type="submit" color="primary" fullWidth>
              Annuler
            </MDButton>
          </MDBox>
          <MDBox sx={{ flexGrow: "1" }}>
            <MDButton type="submit" color="info" fullWidth>
              Modifier
            </MDButton>
          </MDBox>
        </MDBox>
      </form>}
    </MDBox>
  );
}
